<template>
    <div class="pa-3">
        <div class="list pt-3">

            <v-card class="py-6 px-6 mb-2" elevation="2" @dragover="(e) => onDragOver(item, i, e)"
                @dragend="(e) => finishDrag(item, i, e)" @dragstart="(e) => startDrag(item, i, e)"
                v-for="(item, i) in items" draggable="true" :key="item.id">
                <div>
                    <div class="d-flex align-center">
                        <div class="mr-2">{{ i + 1 }}.</div>
                        <div>
                            {{ item.name }}
                        </div>
                    </div>

                </div>
            </v-card>
        </div>
        <v-btn @click="update()">Salvar</v-btn>
    </div>
</template>
<script>
import config from "@/store/config"
import { mapState } from "vuex";
import { initializeApp } from "firebase/app";
import { doc, updateDoc, getFirestore } from "firebase/firestore";

export default {
    name: "SorterArray",
    data: () => ({
        items: [],
        over: {},
        startLoc: 0,
        dragging: false,
        dragFrom: {},
    }),

    props: {
        snap: Array,
    },
    mounted() {
        const items = JSON.parse(JSON.stringify(this.snap))
        const res = []
        items.forEach((item, i) => {
            if (!item.hasOwnProperty('sortIndex') && item.hasOwnProperty('inHome')) {
                if (item.status == 'published' && item.inHome == true) {
                    item.sortIndex = i
                    res.push(item)
                }
            }
        })
        this.items = res

    },

    watch: {
        items: {
            deep: true,
            handler() {
                this.sendSections()
            },
        },
    },
    computed: {
        ...mapState("groupStores", [
            "masterStore",
        ]),
    },

    methods: {
        update() {
            const Sorter = []
            this.items.forEach((item) => {
                Sorter.push(item.id)
            })
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);

            const masterRef = doc(db, "stores", this.masterStore.id);

            updateDoc(masterRef, {
                "packagesSorter": Sorter
            });
        },
        sendSections() {
            this.$emit('update-store', this.items)
            console.log('emit', this.items)
        },
        startDrag(item, i, e) {
            this.startLoc = e.clientY;
            this.dragging = true;
            this.dragFrom = item;
        },
        finishDrag(item, pos) {
            this.items.splice(pos, 1);
            this.items.splice(this.over.pos, 0, item);
            this.over = {};
        },
        onDragOver(item, pos, e) {
            const dir = this.startLoc < e.clientY ? "down" : "up";
            setTimeout(() => {
                this.over = { item, pos, dir };
            }, 50);
        },
    }
}
</script>